import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { acceptPublicOffer } from '../../../thunks/joinOtaIndividual/acceptPublicOffer';
import { saveFormAndAcceptOffer } from '../../../thunks/joinOtaIndividual/saveFormAndAcceptOffer';
import { fetchInitialFormData } from '../../../thunks/joinOtaIndividual/fetchInitialFormData/fetchFormInitialData';

const initialState = false;

const isLoadingSlice = createSlice({
  name: 'joinOtaIndividual/isLoading',
  initialState,
  reducers: {
    setIsLoading(_, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(acceptPublicOffer.pending, () => true);
    builder.addCase(saveFormAndAcceptOffer.pending, () => true);

    builder.addCase(acceptPublicOffer.fulfilled, () => false);
    builder.addCase(saveFormAndAcceptOffer.fulfilled, () => false);

    builder.addCase(acceptPublicOffer.rejected, () => false);
    builder.addCase(saveFormAndAcceptOffer.rejected, () => false);

    builder.addCase(fetchInitialFormData.pending, () => true);
    builder.addCase(fetchInitialFormData.rejected, () => false);
    builder.addCase(fetchInitialFormData.fulfilled, () => false);
  },
});

export const { reducer: isLoadingReducer } = isLoadingSlice;
